/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import TransitionDataHeader from './components/TransitionDataHeader';
import { setErrorMessages, setSuccessMessages } from './store/action';

const TransitionData = ({}) => {
  const dispatch = useDispatch();
  const errorMessages = useSelector(
    (state) => state.sharedState?.TransitionData?.errorMessages
  );
  const successMessages = useSelector(
    (state) => state.sharedState?.TransitionData?.successMessages
  );

  const dispatchSetErrorMessages = (data) => {
    dispatch(setErrorMessages(data));
  };

  const dispatchSetSuccessMessages = (data) => {
    dispatch(setSuccessMessages(data));
  };

  // handling refresh functionality
  useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData') ?? '[]');
    const newObj = updateTabs?.map((item) => {
      if (item.navTo === '/transitionData') {
        if (errorMessages?.length > 0) {
          item.isFormError = true;
        } else {
          item.isFormError = false;
        }
      }
      return item;
    });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [errorMessages]);

  return (
    <div className='tabs-container tBillPanel custom-check'>
      <CustomSeparator
        parent1={'System'}
        parent2={'Technical Window'}
        parent3={'Transition Data'}
      />

      {successMessages && (
        <DisplaySuccessMessages successMessages={successMessages} />
      )}
      {errorMessages && <DisplayErrorMessages errorMessages={errorMessages} />}

      <TransitionDataHeader
        setErrorMessages={dispatchSetErrorMessages}
        setSuccessMessages={dispatchSetSuccessMessages}
        dispatch={dispatch}
      />
    </div>
  );
};
export default TransitionData;
